// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__qvYJ9","pageNumber":"style_pageNumber__OkEWA","active":"style_active__usf41","previous":"style_previous__WokjR","next":"style_next__K17L1"};